var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    rx: 0,
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinejoin: "miter",
    transform: "matrix(1 0 0 1 5 7)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 13.5 0.5 L 7 6.5 L 0 0",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    transform: "matrix(1 0 0 1 5 7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.5 5 L 0 0",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    transform: "matrix(1 0 0 1 14.5 12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.5 5 L 0 0",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    transform: "matrix(-1 0 0 1 9.5 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.47936c315e2d9b1d04a0e074a0f5e82b.svg";
export { ForwardRef as ReactComponent };